import type { ValidationArguments } from "class-validator";
import { registerDecorator } from "class-validator";
import type { ValidationOptions } from "class-validator/types/decorator/ValidationOptions";

/**
 * Validates that a string is trimmed (does not start or end with a space).
 */
export function IsTrimmed(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: "isTrimmed",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value: any) {
                    if (!value) {
                        return true;
                    }
                    return typeof value === "string" && value === value.trim();
                },
                defaultMessage(args?: ValidationArguments) {
                    if (args?.value && typeof args.value !== "string") {
                        return `${propertyName} should be a trimmed string`;
                    }
                    return `${propertyName} can't start or end with a space`;
                },
            },
        });
    };
}
